module.exports = {
    game: 'Game',
    gameNameTranslations: {
      'bingo75lines': 'Bingo 75 Lines',
      'bingo 75': 'Bingo 75 Shapes',
      'paintbynumbers': 'Paint by Numbers'
    },
    prize: {
        currencySymbol: '£',
        currencySymbolForPennies: 'p'
    },
    jackpot: {
        won: 'JACKPOT WON',
        notWon: 'No jackpot winners this game',
        title: 'Jackpot'
    },
    winners: {
        gameWinnersModalTitle: 'Winners',
        previousGameWinners: 'Past 10 Winners',
        previousJackpotWinners: 'Past 10 Jackpot Winners',
        previousBonusGameWinners: 'Past 10 Bonus Game Winners',
        previousHamsterRaceBigWinners: 'Past 10 Largest Winners',
        previous100GameWinners: 'Past 100 Winners',
        tableHeaders: {
          gameId: 'Game Id',
          stamp: 'Stamp',
          winners: 'Winners',
          room: 'Room'
        },
        winnerTemplate: '{username} - £{prize} ',
        winnersWindow: {
          tableHeaders: {
            game: 'Game',
            username: 'Name',
            prize: 'Prize'
          },
          freeze: 'freeze',
          title: 'Game Winners',
          copy: 'Copy'
        },
        popup: {
          title: 'Winner!',
          message: '{username} has won {prize} in {gameName}',
          extendedMessage: '{username} has won {prize} in {gameName} ({prizeType})'
        }
    },
    hamsterRace: {
        lastEigthWinnersTitle: 'Last 8 Winners',
        firstPlace: '1st',
        hamster: 'Hamster',
        wins: 'Wins',
        winners: {
          tableHeaders: {
            winningHamster: 'Winning Hamster'
          }
        }
    },
    rollercoaster: {
        lastSixCallsTitle: 'Last 6 Calls'
    },
    migratedGames: [
      'Bingo 90'
    ],
    arcade: {
      winners: {
        tableHeaders: {
          winnerName: 'Winner Name',
          gameName: 'Game Name',
          prize: 'Prize',
          stamp: 'Stamp'
        }
      },
      gameNameFormat: '{skinName} ({gameName})',
      acceptedSkins: {
        'aztec': 'Aztec',
        'beach': 'Beach',
        'boost': 'Boost',
        'bubble': 'Bubble',
        'carnival': 'Carnival',
        'chests': 'Chests',
        'cincoarc': 'Cinco',
        'classic': 'Classic',
        'cosmos': 'Cosmos',
        'deep': 'The Deep',
        'devils': 'Devils',
        'diner': 'Diner',
        'drop': 'Drop',
        'egyptian': 'Egyptian',
        'emoji': 'Emoji',
        'forest': 'Forest',
        'galleon': 'Galleon',
        'goldrush': 'Goldrush',
        'heist': 'Heist',
        'heroes': 'Heroes',
        'jellyfish': 'Jellyfish',
        'jesters': 'Jesters',
        'jungle': 'Jungle',
        'lab': 'Lab',
        'lamps': 'Lamps',
        'medieval': 'Medieval',
        'minotaur': 'Minotaur',
        'newyear': 'Chinese New Year',
        'oriental': 'Oriental',
        'parade': 'Parade',
        'paradise': 'Paradise',
        'phoenix': 'Phoenix',
        'pop': 'Pop',
        'pub': 'Pub',
        'retro': 'Retro',
        'sacred': 'Sacred Stone',
        'snapshot': 'Snapshot',
        'space': 'Space',
        'spellbound': 'Spellbound',
        'stack': 'Stack',
        'suits': 'Suits',
        'temple': 'Temple',
        'treasure': 'Treasure',
        'tribe': 'Tribe',
        'vikings': 'Vikings',
        'wantedwild': 'Wanted Wilds',
        'wildwoods': 'Wild Woods',
        'pirate' : 'Pirate\'s Curse',
        'dominoes' : 'Dominoes',
        'halloween' : 'Halloween',
        'dstns' : 'Destinations',
        'numbers' : 'Numbers',
        'winter' : 'Winter',
        "words" : "Words",
        "gaelic": "Gaelic",
        "neon": "Neon",
        "explore": "Explore",
        "bankbonus" : "Banker\'s Bonus",
        "mrsclaus" : "Christmas Wish",
        "bankvault" : "Banker\'s Vault",
        "rhythm" : "Trax",
        "cdemayo": "Fiesta",
        "gonefish": "Gone Fishin'",
        "firefly": "Firefly"
      }
    },
    quizQuids: {
      tableHeaders: {
        winnerName: 'Winner Name',
        chatModeratorName: 'Chatmod Name',
        stamp: 'Stamp'
      }
    },
    pictureBingo: {
      winners: {
        tableHeaders: {
          theme: 'Theme'
        }
      }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/en/game.js
// module id = nywV
// module chunks = 1